import React, { Component } from 'react';

class ContactMe extends Component {
    constructor() {
        super();
        this.state = {
            showCopied: false
        }
    }

    copyKey() {
        var copyText = document.getElementById("my-pubkey");
      
        navigator.clipboard.writeText(copyText.innerText);

        this.setState(state => {
            return ({
                ...state,
                showCopied: true
            });
        });

        setTimeout(() => {
            this.setState(state => ({...state, showCopied: false}));
        }, 3000);        
      }

    render() {
        return (
          <article
            id="contact"
            className="content-article active-article add-padding animated fadeIn"
          >
            <section className="hero is-primary">
              <div className="hero-body">
                <h1 className="title flex-center-content">Contact Me</h1>
              </div>
            </section>
            <p className="add-top-30">
              Will is currently employed full-time and is not accepting
              freelance contracts. However, if you have a volunteer opportunity,
              please feel free to reach out to him at the email below.
            </p>
            <a href="mailto:will@williamjohnsonjr.com">
              will@williamjohnsonjr.com
            </a>{" "}
            |{" "}
            <a href="https://github.com/WilliamJohnsonJr">
              https://github.com/WilliamJohnsonJr
            </a>
            <p className="bold add-top-10">
              Availability (check here for updates)
            </p>
            <p className="italic">
              Will is currently <span className="bold">not</span> available for
              new freelance projects at this time.
            </p>
            <p className="add-top-10">
              If you want to send a confidential message to Will, you may do so
              using this PGP Public Key:
            </p>
            <button type="button" className="pointer flex-center-content" onClick={() => this.copyKey()}>
              <i className="fa-solid fa-copy" aria-hidden="true"></i>
              <span>Copy to clipboard</span>
            </button>
            {this.state.showCopied && (<p>Copied to clipboard!</p>)}
            <pre id="my-pubkey">-----BEGIN PGP PUBLIC KEY BLOCK----- mQINBGRlpaQBEAC5DKM2B5w0aKpa7hTAPh6L3RrGMPGsRamt/gzbwf7IO6ET40ck luUDM0gwthqCsBwYgfYWvRH2OpzY3aPGkc7zSihQ/hvDD1R97jeMw3bBE1AKSCPG Re4hfRBsy4uiTohdOLHQGtAW8U4ypMH3ZWGlcjyrUsKNVw9ddhKh+8HEl1XS33PS TsljkOlpq5b/1B2g/F2wF5YhNV2W6WuVKb+gZSf49VgJTxtgpibFDmFd8AEvZLfQ KDdhEAxxv0WjE+Ku3xdct4qNymDCixCutfQX/Ko/9otKO9nvtZyWpsD5oU3l3Bsh 8yTrSfEiI7ElWwjVNkkW6PW9+XEyb9Eewx66RzO194HGx06WJwVhzBLRX/SlAQTi g2/Bf4Lbz05IhWj1pC+2rpDHorIgsBxkJBH0cLL4H2GC/EhamDSdm9fBS6+yhTQ0 etvQah8iKggTGZ1iV4+Un98iUk4V1Zcx3S+zEZSARA6Wp5IpE9mf1b+xrIBXfnSi GD+wJv8HJVvyPVJ/Pk4N7+ubppobOCMnNFQOe3rWbkc99zr6YTM8L3xuK4DmxaOF 0BsqYNec5NB3+v7Nt0SbZ6YntaOPIB9IDEk+hx7njjT/+W3iLUdPNC1BWu7PzL7N lUTFYaBCscVf4n5U+2EhGcaKwDU+MdaBbC/1zehdzUtc5b7g3SOtZGbUqwARAQAB tChXaWxsIEpvaG5zb24gPHdpbGxAd2lsbGlhbWpvaG5zb25qci5jb20+iQJUBBMB CAA+FiEEbkRvwIGQ/6ehnf+G8cRKggWWrRwFAmRlpaQCGwMFCQeGH4AFCwkIBwIG FQoJCAsCBBYCAwECHgECF4AACgkQ8cRKggWWrRwOjRAAgxSsf5ns/ND8/uLeRxLI e06/vHPDgL/GwFnWIFoghLYOdUFfOI46OGhYhrjiAlsuQtBLHUv30PVPxlWX6oLz /9zSftbf1Fzcktd9BWpQqHdqjApT0YRv2Ani88eNCA4MN+HFDuZrzel4iHsfV+Du hi3fJjSS75GEnEf1462axmrzOZL+gVWMwWVac2VMdTuAf3S/cGn+3H3gY6hlXU62 EiH1FPciPthywv6bSe3gFM2+7vBjA1YGhYXu+VnUQoN2OjMLp1wEB98mVAMD0cpD W/NDJTXX/4WPmm9lOzPhftl3jeT0MxhG7ePuMZhzQLCaRps7Y/J3SidiAnw36rSM Y2gGDHLohMC4PaoRhjF6cZ30dRKM+cFOaMmSBFHoX7xWKTeeNn3dckCgy9B+ZxJy jmkMu0LgZqmSSbVhPgu8e6/3DsfabcUl3quCvV6LYGp3uv6Ezpcl9Y/LLWdzeWli BEbHz/EpvI0laUbMpi3F77yEVuPRiiiIC9SWF/Mp+ZM5D5/YojoPVUmiVYcBJ6Fv HbHG4udBUV5oUfowsRDMV2BKTJt9OhEj7rL+T1YUSE9B5fVw3w0Y5hPu+iaXWyzn BSXPDsmZzngNTS2MteXkjnxgiLgtFEa56curp98f0YCcAN+EcWKWeQhhHdxDfPZP ffWGG84wPAowdnbICorSPae5Ag0EZGWlpAEQALZWvDxzzOC7WsJeJD2m7+TOUk8X b2IEYVYC/OckuAGvxLTjspN9p/6G6IZCQBhBfrxS5RKOlHmFaAvLZ0CosmzV02Wu sUrKFqvM6XHX7YY9X8KNwr/UaqXi4W7kWPjORp4SO5Z6k+8A0p08M5KOkBOUekwF DG/I0hEBFdysG9qFDKy7DTEBCkokey9IXxGubO3vIfIsEVSC9mgTeFL8FeCjQrii SjWZKYN+f2Pv+ETR5/I/rfY0WIEtJz2WFwWLV6bX8JGoBA9bZv1WA1giEIO915P5 3QOMHduJgAh2LCoUhEczK+YtkHO3g0cdxNg4i7zFEJMuLQLcwGOlBrY1zDoMyJoR yeLHmLyvgNqlU/5G8viGAVRVainTTK2HxE5R1WVQnbsIwhn4vfNJJhYOazFleRET aWVftwagR+ecjqclaQxtUZEE4cxhnG9KHF48BSujlbWRlodEukJtujc1AlLn2FsQ fjeJkbTYFVrDLdYYYvpAf/tfanCa94Ammp/TrE60gv5CVhmKH7zC/l2V2fsAowo5 dxu/rfDDG+TOJtlRp3yNzbdXa5HiuL24KAVGbhx3M9uWpm6iPrFtml+snEWvw+d7 McvTCRBTIKqYvDeIcMNodiCDLKkwhDJtQPevuitFDFO/TV/NQ4jDBtftpZvlMVJu 98+SRrCgAyys4mwDABEBAAGJAjwEGAEIACYWIQRuRG/AgZD/p6Gd/4bxxEqCBZat HAUCZGWlpAIbDAUJB4YfgAAKCRDxxEqCBZatHAk3D/9RXdPL0oDWoHp729z1fWyI ApAINMK5mtbWSd76T42sIZ6bJ1UnK6gQBiaRASXrCR2GdtlmqlUNYkl4gqqN+rsy K2p0Ty1aDA31HFiiHoseXFch7yWx2oJmrgsE/Ni4OGW0FK/jzn0n5Q2qutVnUDYx YZ2k6FoBsLL4DjOP0gP7OWn6JXk/Q9wrh/a48h31fEKLya13268nsmlFLfX2H59I ieb0oPGHezSEWwpurIyQsmBeL7ZPJTvTlE5lF79hOKmm+svHAY2C0cTDTe4NmO9A J5GK6x83UQ8s+8FxhDMvL0HV6KsxIAZ5CXt66riG+uT1CeuV4uUafaPH75hUyZ3R tvtBug50GP2tuKmNDZux+iyv0cjFkG/YyEcAc/pubxBT/rF/0y8204TYaefFDWYy DJaLG6+u62qx6QiwuLHD1BYS/Y6FEwSKNxx7hKVeN5uNZUr6CMaOrv54icuYVWIm f6dkPIzpT5fA+r0uhv2kVZn4bT7pxraI4CwJR2ihQkZKfDXRBNw+TbCIPd+BV47O sSggMsfPBGCJuFEalj4tHdMnwCzSb81tltVvmdGGWsN8QEBOea3vl8kNTaCpznxv LLQeKMoqCCT/7JNwq6JC+/1G1GsHQguP/93iyW8npaljkjN46bU5kjQpy7rJFkTF nTgBp71you3BKv3AuKUmtA== =19Tu -----END PGP PUBLIC KEY BLOCK-----</pre>
          </article>
        );
    }
}

export default ContactMe;